import { RESET_STATE } from 'store/global/actions';

import { DOCUMENT_EXPIRATION_DATES_ACTION_TYPE } from '../actions';

const initialState = [];

const documentExpirationDatesReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case DOCUMENT_EXPIRATION_DATES_ACTION_TYPE.GET_EXPIRATION_DATES:
      return payload || state;

    case DOCUMENT_EXPIRATION_DATES_ACTION_TYPE.CREATE_DOCUMENT_EXPIRATION_DATE:
      return [...state, payload];

    case DOCUMENT_EXPIRATION_DATES_ACTION_TYPE.CREATE_DEFAULT_DOCUMENT_EXPIRATION_DATE: {
      const { idToReplace, ...documentExpirationDate } = payload;

      return state.map(item => (item.id === idToReplace ? documentExpirationDate : item));
    }

    case DOCUMENT_EXPIRATION_DATES_ACTION_TYPE.EDIT_DOCUMENT_EXPIRATION_DATE: {
      return state.map(item => (item.id === payload.id ? payload : item));
    }

    case DOCUMENT_EXPIRATION_DATES_ACTION_TYPE.DELETE_DOCUMENT_EXPIRATION_DATE: {
      return state.filter(({ id }) => id !== payload.id);
    }

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default documentExpirationDatesReducer;
